// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"476":"276a4464","661":"1f639a45","845":"1e75bca0","862":"89faa713","881":"fd76b788"}[chunkId] + ".js";
};